export default {
    methods: {
        /**
         * Create a conversation if the contact has a valid phone.
         */
        triggerValidatePhones(contact) {
            return new Promise((resolve, reject) => {
                const validPhone = contact.phones.find(p => p.valid && p.type == 'mobile');
                const unvalidatedPhones = contact.phones.filter(p => !p.validated);

                if (validPhone) {
                    resolve();
                    return;
                }

                if (empty(unvalidatedPhones)) {
                    reject();
                    return;
                }

                this.validatePhones(unvalidatedPhones)
                    .then(() => resolve())
                    .catch(() => reject());
            });
        },

        /**
         * Validate a list of phone numbers until a valid phone is found.
         * If a valid phone is found, a conversation is created.
         */
        async validatePhones(phones) {
            let found = false;

            for (const phone of phones) {
                found = await this.validatePhone(phone); // eslint-disable-line no-await-in-loop

                if (found) {
                    return;
                }
            }

            throw new Error('No valid phone found.');
        },

        /**
         * Validate a phone number
         */
        validatePhone(phone) {
            return new Promise((resolve, reject) => {
                this.$axios.get(`contact-phones/${phone.id}/validate`)
                    .then(response => {
                        resolve(response.data.data.valid && response.data.data.type == 'mobile');
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    },
};
